import { useRouter } from 'next/router'

import { Button } from '@wartek-id/button-v1'
import { Dialog, DialogOverlay, DialogContent } from '@wartek-id/dialog-v1'
import type { DialogProps } from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'
import { useToast } from '@wartek-id/toast'

import { assetUrl } from 'utils/url'
import { useAPIPostPelaksanaanAppealRollback } from 'api/kinerja/useAPIKinerja'

import type { TPelaksanaanAppealableStep } from 'types/kinerja-pelaksanaan'

type PelaksanaanAppealRollbackDialogProps = Omit<DialogProps, 'children'> & {
  onSuccess?: () => void
  onCancel?: () => void
  url: string
  step: TPelaksanaanAppealableStep
}

export function PelaksanaanAppealRollbackDialog({
  onSuccess,
  onCancel,
  step,
  url,
  ...dialogProps
}: PelaksanaanAppealRollbackDialogProps) {
  const router = useRouter()
  const toast = useToast()
  const mutationPelaksanaanAppealRollback =
    useAPIPostPelaksanaanAppealRollback()

  const handleConfirm = () => {
    mutationPelaksanaanAppealRollback.mutate(
      { appealState: step, tipe: 'GPK' },
      {
        onSuccess: () => {
          onSuccess?.()
          router.push(url)
        },
        onError: () => {
          toast({
            message: 'Gagal lanjut. Coba lagi.',
          })
        },
        onSettled: () => {
          dialogProps.onClose?.()
        },
      }
    )
  }

  return (
    <Dialog size="sm" {...dialogProps}>
      <DialogOverlay />
      <DialogContent
        aria-labelledby="appeal-rollback-dialog-title"
        aria-describedby="appeal-rollback-dialog-description"
      >
        <div className="p-6 space-y-4">
          <img
            src={assetUrl('/illustrations/img-document-sync-data.png')}
            alt=""
            height={84}
            width={84}
          />

          <div className="space-y-1">
            <Text
              variant="display-sm"
              as="h3"
              id="appeal-rollback-dialog-title"
            >
              Konfirmasi untuk Mengubah Isi
            </Text>
            <Text
              color="subdued"
              variant="body-lg"
              id="appeal-rollback-dialog-description"
            >
              Jika lanjut ubah, isi akan menjadi draf dan harus dikirim ulang.
            </Text>
          </div>
          <div className="flex space-x-5">
            <Button
              onClick={onCancel}
              color="white"
              size="lg"
              disabled={mutationPelaksanaanAppealRollback.isLoading}
            >
              Kembali
            </Button>
            <Button
              onClick={handleConfirm}
              color="blue"
              size="lg"
              isLoading={mutationPelaksanaanAppealRollback.isLoading}
              disabled={mutationPelaksanaanAppealRollback.isLoading}
            >
              Konfirmasi
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
